/**
 * **climax の演出**（Issue #544 / #545。索引 #539）。**1 ファイル = 1 状況 × 役割**（ファイル名が `<situation>_<role>`。Issue #629）。
 * 状況は共通側の分岐レイヤー `editorPorts/duelSituations/` のカタログの名前（`move_destroy` / `new_turn` …。テーマは core のイベントを知らず、
 * 判定も書かない。絵の組み立ては `../fx/` の variant を引数に取る関数）。役割は `_motion`（カードを動かす演出）と `_effect`（強調の演出）で、
 * どちらか一方だけでもよい。2 つは別の帯で、motion → effect の順に**重ならず**並ぶ。
 * 状況を持つイベントで**ファイルを置いていない状況は出ない**（move の `leave` / `material` / `destroy_elsewhere`、
 * material_summon の synchro / fusion / tribute / ritual 以外）。`spsummoning` は状況ごとのファイルが全部同じ組み立て（`../fx/spsummoning.js`）を呼ぶ（専用バンクは #598〜#602）。
 *
 * 置けば出る・消せば出ない。`require.context` は使わない（jest と webpack で読み方が変わるのを避ける）。
 * 共有の組み立ては `../fx/`（`effects/` にはイベントのファイルしか置かない）。
 */
import attackDirect from './attack_direct_effect';
import attackMonster from './attack_monster_effect';
import attackDisabled from './attack_disabled_effect';
import battleDirect from './battle_direct_motion';
import battleMonster from './battle_monster_motion';
import becomeTarget from './become_target_field_effect';
import becomeTargetElsewhere from './become_target_elsewhere_effect';
import chainDisabled from './chain_disabled_effect';
import chainEnd from './chain_end_effect';
import chainNegated from './chain_negated_effect';
import chainSolved from './chain_solved_effect';
import chainSolvingSink from './chain_solving_sink_effect';
import chainSolvingZoom from './chain_solving_zoom_effect';
import chained from './chained_effect';
import chainingElsewhere from './chaining_elsewhere_effect';
import chainingField from './chaining_field_motion';
import confirmDecktop from './confirm_decktop_effect';
import damageBattle from './damage_battle_effect';
import damageEffect from './damage_effect_effect';
import damageStepEnd from './damage_step_end_effect';
import draw from './draw_effect';
import flipsummoned from './flipsummoned_effect';
import materialSummonSynchro from './material_summon_synchro_effect';
import materialSummonFusion from './material_summon_fusion_effect';
import materialSummonTribute from './material_summon_tribute_effect';
import materialSummonRitual from './material_summon_ritual_effect';
import flipsummoningEffect from './flipsummoning_effect';
import flipsummoningMotion from './flipsummoning_motion';
import moveAfterActivation from './move_after_activation_motion';
import moveDestroy from './move_destroy_motion';
import moveElsewhere from './move_elsewhere_effect';
import moveEnter from './move_enter_motion';
import newPhaseBattle from './new_phase_battle_effect';
import newPhaseOther from './new_phase_other_effect';
import newTurn from './new_turn_effect';
import payLpcost from './pay_lpcost_effect';
import posChangeFlipEffect from './pos_change_flip_effect';
import posChangeFlipMotion from './pos_change_flip_motion';
import posChangeSpell from './pos_change_spell_motion';
import posChangeTurnEffect from './pos_change_turn_effect';
import posChangeTurnMotion from './pos_change_turn_motion';
import recover from './recover_effect';
import spsummoned from './spsummoned_effect';
import start from './start_effect';
import spsummoningPlain from './spsummoning_plain_effect';
import spsummoningSynchro from './spsummoning_synchro_effect';
import spsummoningFusion from './spsummoning_fusion_effect';
import spsummoningRitual from './spsummoning_ritual_effect';
import spsummoningXyz from './spsummoning_xyz_effect';
import spsummoningLink from './spsummoning_link_effect';
import statChange from './stat_change_motion';
import summoned from './summoned_effect';
import summoning from './summoning_effect';
import win from './win_effect';

export const EFFECTS = Object.freeze([
  attackDirect, attackMonster, attackDisabled, battleDirect, battleMonster, becomeTarget, becomeTargetElsewhere, chainDisabled, chainEnd, chainNegated, chainSolved,
  chainSolvingSink, chainSolvingZoom, chained, chainingElsewhere, chainingField, confirmDecktop, damageBattle, damageEffect, damageStepEnd, draw,
  flipsummoned, flipsummoningEffect, flipsummoningMotion, materialSummonSynchro, materialSummonFusion, materialSummonTribute, materialSummonRitual, moveAfterActivation, moveDestroy, moveElsewhere, moveEnter, newPhaseBattle, newPhaseOther, newTurn,
  payLpcost, posChangeFlipEffect, posChangeFlipMotion, posChangeSpell, posChangeTurnEffect, posChangeTurnMotion, recover, spsummoned, spsummoningPlain, spsummoningSynchro, spsummoningFusion, spsummoningRitual, spsummoningXyz, spsummoningLink, start, statChange, summoned, summoning, win,
]);
